import { MaterialReactTable } from 'material-react-table'
import { TeamMember } from 'src/stores/AdTeamStore'
import styled from 'styled-components'

const TableHeaderSx = {
  backgroundColor: '#30515B',
  color: 'white',
  fontSize: '14px',
  textAlign: 'center',
  '& .Mui-TableHeadCell-Content': {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    height: '100%',
  },
  '&:first-of-type': {
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
  },
  '&:last-of-type': {
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
  },
}

const TableCellSx = {
  textAlign: 'center',
  verticalAlign: 'middle',
  fontSize: '16px',
}

const TableRowSx = {
  height: '49px',
  '& > td:first-of-type': {
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
  },
  '& > td:last-of-type': {
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  '& > td': {
    background: '#FFF',
    boxShadow: '1px 2px 2px rgba(0, 0, 0, 0.1)',
    padding: '4px',
  },
}

const AreaChip = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 4px 10px;
    border-radius: 39px;
    background-color: #00A7D8;
    line-height: normal;
    width: 50px;
    color: white;
`

interface Props{
    PropsData : TeamMember[]
}

const RightTable = ({PropsData}:Props) => {
  return (
        <MaterialReactTable
            data={PropsData}
            enableStickyHeader
            muiTableContainerProps={{
            sx: { 
                  height: '100%',
                  maxHeight: '100%',
                  overflow: 'auto',
                }
            }}
            columns={[
            {
              accessorKey: 'leader',
              header: '', // 헤더 비움
              Cell: ({ cell }) => {
                const isLeader = cell.getValue<number>() === 1;
                return isLeader ? 
                <div style={{width:'100%', display:'flex',justifyContent:'center',alignItems:'center'}}>
                <AreaChip>팀장</AreaChip>
                </div> 
                : 
                null;
              }
            },
            { accessorKey:'user_name', header: '이름'},
            { accessorKey:'user_id',header: '아이디'},
            { accessorKey:'phone',header:'연락처'},
            ]}
            // 툴바, sort 버튼 등
            enableSorting={false} // ✅ 전체 정렬 기능 제거
            enableTopToolbar={false}
            enableBottomToolbar={false}
            enableColumnActions={false}
            muiTablePaperProps={{
            elevation: 0, // ✅ 그림자 제거
            }}
            // 로우 헤더 스타일
            muiTableHeadCellProps={{
            sx: TableHeaderSx,
            }}
            // 로우 스타일
            muiTableBodyRowProps={({ row }) => ({
              sx: {...TableRowSx,
              }
            })}
            // 셀 스타일
            muiTableBodyCellProps={{
            sx: TableCellSx,
            }}
            // 테이블 스타일
            muiTableProps={{
            sx: {
                borderCollapse: 'separate',
                borderSpacing: '0 5px', // ✅ row 간격 5px
                // '& .MuiTableSortLabel-icon': {
                // color: '#aaa',
                // fontSize: '1.5rem',
                // },
                // '& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': {
                // color: 'rgb(255, 255, 255) !important',
                // },
            }}}
            // 페이지 네이션 옵션
            manualPagination 
            // 솔팅 옵션
            manualSorting
            enableSortingRemoval={false}
            enableRowSelection={false}
            enableRowActions={false}
            />
  )
}

export default RightTable